import * as React from 'react';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import IconButton from '@material-ui/core/IconButton';
import './TabsThreadChat.css';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';

import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { setPanelSelector } from '@/state/selector/panelSelector';
import { userAtom } from '@/state/atom/userAtom';
import { Popover, Tooltip } from '@material-ui/core';
import { isEditedMsgInprogressAtom } from '@/state/atom/panelAtom';
import { DialogConfirmChangeTabChat } from './messageDialog/DialogConfirmChangeTabChat';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import { getVisibleWidth, handlerChangeTabThreadChat, scrollToActiveTab } from './handler/ChatThreadHandler';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-auto-tabpanel-${index}`}
            aria-labelledby={`scrollable-auto-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(type) {
    return {
        id: `scrollable-auto-tab-${type}`,
        'aria-controls': `scrollable-auto-tabpanel-${type}`,
    };
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

export default function TabsThreadChat(props) {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    // item menu tabs
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const [isEditedMsgInprogress, setIsEditedMsgInprogress] = useRecoilState(isEditedMsgInprogressAtom);

    // end item menu tabs
    // common userDetail state
    const userDetail = useRecoilValue(userAtom);
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);

    const addNewPanel = useSetRecoilState(setPanelSelector);

    const isArchive = props.ticketOriginInfor.liveOrArchived === Constant.LIVE_OR_ARCHIVED.ARCHIVED;

    const handleClickTabThreadChat = async(thread, isScroll = false, nextIndex = 0, tabList = []) => {
        if(thread.id === props.selectThread.id) return;
        props.setChangeToThread(thread);
        if(isEditedMsgInprogress) {
            props.setIsOpenConfirmChangeThread(true);
        } else {
            if (isScroll) setAnchorEl(null);
            await handlerChangeTabThreadChat(thread, props, props?.projectInuseDetail?.id);
            
            if (isScroll) {
                scrollToActiveTab(nextIndex, tabList, props.selectThread?.id);
            }
        }
    };

    const handleAddPanel = () => {
        addNewPanel({
            //type: Constant.PANEL_TYPE.ADD_TICKET, 
            type: Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL,
            tabId: `${Constant.TAB_PANEL_TYPE.QA_NEW_TICKET_TAB}_${props.ticketId}_${Date.now().toString()}`,
            ticketId: props.ticketId, 
            props: {
                ...props,
                createTicketType: Constant.TICKET_TYPE.ESCALATION,
                ticketId: props.ticketId
            },
        });
    }

    let timeoutEvent;
    const onWheel = (event, tabList) => {
        const element = document.querySelector(`.MuiTabs-flexContainer`);
        element.scrollLeft += event.deltaY > 0 ? Constant.SCROLL_LEFT_CHANGE : Constant.SCROLL_LEFT_CHANGE * -1;
        event.stopPropagation();
        let containerRect = element.getBoundingClientRect();
        let posElem = [];
        for (let i = 0; i < tabList.length; i++) {
            // Gets the amount of pixels currently visible within the container
            let visiblePageWidth = getVisibleWidth(tabList[i]);
            posElem.push({ pos: visiblePageWidth });
        }

        // trigger wheel end
        if (timeoutEvent) clearTimeout(timeoutEvent);
        timeoutEvent = setTimeout(() => {
            for (let i = 0; i < posElem.length; i++) {
                let item = posElem[i];
                if (item.pos.left + item.pos.width >= item.pos.width * Constant.LIST_VIEW_TAB) {
                    element.scrollLeft += item.pos.width - (containerRect.width - item.pos.left);
                    break;
                }
            }
        }, Constant.TRIGGER_TIMEOUT_WHEEL_END);
    };

    const isDisplayBtnCreateTicketEscalate = () => {
        let anonymousUserInfo = props.ticketOriginInfor?.anonymousUserInfo;
        if(anonymousUserInfo?.type === Constant.ANONYMOUS_TYPE.CHATBOT_LIVECHAT &&  props.ticketOriginInfor.anonymousQaStatus !== Constant.ANONYMOUS_TICKET_STATUS.CHAT_NOW) {
            return false;
        }
        return (
            (props.ticketOriginInfor?.ticketType === Constant.TICKET_TYPE.QA ||
                props.ticketOriginInfor?.ticketType === Constant.TICKET_TYPE.INTERNAL_QA ||
                props.ticketOriginInfor?.ticketType === Constant.TICKET_TYPE.EXTERNAL_QA ||
                props.ticketOriginInfor?.ticketType === Constant.TICKET_TYPE.DELEGATE ||
                props.ticketOriginInfor?.ticketType === Constant.TICKET_TYPE.EMAIL ||
                props.ticketOriginInfor?.ticketType === Constant.TICKET_TYPE.EMAIL_REPLY ||
                props.ticketOriginInfor?.ticketType === Constant.TICKET_TYPE.TELEPHONE ||
                props.ticketOriginInfor?.ticketType === Constant.TICKET_TYPE.ESCALATION) &&
            props.isTargetProjectOfTicket &&
            props.isAtTicketDetail &&
            !Utils.isProjectGuest(projectInuseDetail) &&
            !Utils.isProjectGuestDesk(projectInuseDetail) &&
            Utils.isGeneralUserWithoutGuest(userDetail) &&
            !Utils.isTrainingTicket(props.ticketOriginInfor)
        );
    };

    return (
        <div className="tabs-info">

            <div className="tabs-wrap tabs-wrap--chat">
                <div className="navTabs">
                    <div className="navTabsChat">
                        <AppBar className="navTabs-box" position="static">
                            <Tabs
                                className="navTabs-rot"
                                value={props.selectThread?.id}
                                // value={value}
                                // onChange={handleChange}
                                // value={value}
                                // onChange={handleChange}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="scrollable"
                                scrollButtons
                                // allowScrollButtonsMobile
                                aria-label="scrollable auto tabs example"
                                data-cy="thread-chat-tabs-frame"
                                onWheel={event => onWheel(event, props.threadChatList)}
                            >
                                {(!Utils.isEmptyArray(props.threadChatList) && props.threadChatList.length > 1) && props.threadChatList.map(item => {
                                    let itemColor = 'item-color-escalate';
                                    if (
                                        item.data.colorTabThread === Constant.COLOR_THREAD_CHAT.CUSTOMER_TAB &&
                                        item.data.id === props.selectThread?.id
                                    ) {
                                        itemColor = 'item-color-customer';
                                    }
                                    if (
                                        item.data.colorTabThread === Constant.COLOR_THREAD_CHAT.INTERNAL_TAB &&
                                        item.data.id === props.selectThread?.id
                                    ) {
                                        itemColor = 'item-color-internal';
                                    }
                                    if (
                                        item.data.colorTabThread === Constant.COLOR_THREAD_CHAT.REFERENCE_TAB &&
                                        item.data.id === props.selectThread?.id
                                    ) {
                                        itemColor = 'item-color-reference';
                                    }
                                    if (
                                        item.data.colorTabThread === Constant.COLOR_THREAD_CHAT.AI_ASSISTANT_TAB &&
                                        item.data.id === props.selectThread?.id
                                    ) {
                                        itemColor = 'item-color-ai-assistant';
                                    }
                                    return(
                                        <Tab
                                            className={`navTabs--item-chat navTabs--item-${item.data.id} ${itemColor}`}
                                            label={<OverFlowTooltipWithTabsMui value={item.label} />}
                                            onClick={() =>
                                                handleClickTabThreadChat(item.data, false)
                                            }
                                            {...a11yProps(item.data.id)}
                                            value={item.data.id}
                                            data-cy={item.dataCy}
                                        />
                                )})}
                            </Tabs>
                        </AppBar>
                        
                    </div>
                    {props.threadChatList.length > 4 && (
                         <div className="gNav-tabs">
                            <IconButton
                                className="panel-tab-seemore itemNav"
                                aria-label="more"
                                id="long-button"
                                aria-controls={open ? 'long-menu' : undefined}
                                aria-expanded={open ? 'true' : undefined}
                                aria-haspopup="true"
                                onClick={handleClick}
                            >
                                <img src="/assets/image/icon-navTabs.svg" alt="see-more" />
                            </IconButton>
                            <Popover
                                className="navTabs-drop navTabs-drop--changePd navTabs-drop-mw144 "
                                id={open ? 'simple-popover' : undefined}
                                open={open}
                                anchorEl={anchorEl}
                                onClose={handleClose}
                                style={{maxHeight: '200px'}}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center'
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center'
                                }}
                            >
                                <ul className="list-view-seemore">
                                    {props.threadChatList.map((item, index) => (
                                        <li 
                                            className={props.selectThread?.id === item.data.id ? 'active' : ''}
                                            onClick={() =>
                                                handleClickTabThreadChat(item.data, true, index, props.threadChatList)
                                            }
                                        >
                                            {<OverFlowTooltipWithTabsMui value={item.label} />}
                                        </li>
                                    ))}
                                </ul>
                            </Popover>
                        </div>
                        )
                    }
                    <div className="itemChat">
                        {isDisplayBtnCreateTicketEscalate() && (
                            <div className="itemButton">
                                <Tooltip title={trI18n('USER04LB065')} placement='top' arrow >
                                    <IconButton
                                        className="btnAdd-ticket"
                                        onClick={() => {
                                            handleAddPanel();
                                        }}
                                        data-cy="btn-add-escalation-ticket"
                                        disabled={isArchive || !Utils.isEmptyString(props.ticketOriginInfor.deletedAt)}
                                    >
                                        <img src="/assets/image/icon-addTicket.svg" alt="" />
                                    </IconButton>
                                </Tooltip>

                            </div>
                        )}

                        <DialogConfirmChangeTabChat 
                            {...props}
                            changeToThread={props.changeToThread} 
                            isOpenConfirmChangeThread={props.isOpenConfirmChangeThread}
                            setIsOpenConfirmChangeThread={props.setIsOpenConfirmChangeThread}
                            setIsEditedMsgInprogress={setIsEditedMsgInprogress}
                            selectedProjectId = {props?.projectInuseDetail?.id}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
